import { RESOURCES_COLUMNS } from '@elementary/common-ui/constants/queryKeys';
import useGraphqlQuery from '@elementary/common-ui/hooks/useGraphqlQuery';
import useSelectedEnv from '@elementary/common-ui/hooks/useSelectedEnv';
import { getTestManagementAssetColumnsQuery } from 'shared/services/api';
import {
  AssetColumnsByAssetId,
  TestManagementGqlAssetColumnsResponse,
} from 'shared/types';

const groupByAssetId = (
  data: TestManagementGqlAssetColumnsResponse,
): AssetColumnsByAssetId => {
  const byAssetId: AssetColumnsByAssetId = {};
  (data?.tableAssetColumns ?? []).forEach(([assetId, name, dataType]) => {
    (byAssetId[assetId] ??= []).push({ name, type: dataType });
  });
  return byAssetId;
};

type Props = {
  enabled?: boolean;
  onError?: () => void;
};

const useTestManagementAssetColumns = ({
  enabled = true,
  onError,
}: Props = {}) => {
  const selectedEnvId = useSelectedEnv();

  return useGraphqlQuery<AssetColumnsByAssetId>({
    query: getTestManagementAssetColumnsQuery,
    queryKey: [RESOURCES_COLUMNS, selectedEnvId],
    enabled,
    onError,
    select: groupByAssetId,
  });
};

export default useTestManagementAssetColumns;
